<div class="filters">
    <ssg-side-filter (apply)="applyEdits()" (reset)="clearEditFilters()" (toggle)="toggleFilters($event)"
      [isDisabled]="!editFilters" [isInvalid]="!editFilters || editFilters.isFormInvalid()"
      class="flex-column">
      <div *ngIf="editFilters" class="flex-fill flex-column">
        <ukg-popover #quickFiltersTooltip>
          <span>
            <b><span translate>STALE_DATED_CHECKS.FILTER_QUICK_FILTERS_LABEL</span></b>
            <br />
            <p translate>STALE_DATED_CHECKS.FILTER_QUICK_FILTERS_TOOLTIP</p>
  
            <ukg-list>
              <ukg-list-item>
                <p [innerHtml]="'STALE_DATED_CHECKS.CURRENT_UPCOMING_CHECK_INFO' | translate"></p>
              </ukg-list-item>
              <ukg-list-item>
                <p [innerHtml]="'STALE_DATED_CHECKS.UPCOMING_CHECK_INFO' | translate"></p>
              </ukg-list-item>
              <ukg-list-item>
                <p [innerHtml]="'STALE_DATED_CHECKS.PAST_CHECK_INFO' | translate"></p>
              </ukg-list-item>
            </ukg-list>
          </span>
        </ukg-popover>
  
        <ukg-icon name="help" (click)="quickFiltersTooltip.present($event.target)"></ukg-icon>
        <div class="wrap-container vertical-spacing">
          <div style="display:flex">
            <ukg-input-container [block]="true" [size]="medium">
              <div text-wrap data-automation="quick_filters_label" translate>
                STALE_DATED_CHECKS.FILTER_QUICK_FILTERS_SHOW_LABEL</div>
              <ukg-select data-automation="quick_filters_dropdown" [multiple]="false"
                [(ngModel)]="selectedDurationType" bindLabel="localizedName">
                <ukg-select-option *ngFor="let durationType of allDurationType" [value]="durationType"
                  [label]="durationType.localizedName"></ukg-select-option>
              </ukg-select>
            </ukg-input-container>
          </div>
        </div>
        <div class="wrap-container vertical-spacing flex-row flex-gap-5pct">
  
          <ukg-input-container [block]="true" [size]="medium">
            <div text-wrap data-automation="pay_group_edit_label" translate>AT_A_GLANCE.PAY_GROUP_LABEL</div>
            <ukg-select data-automation="pay_group_edit_dropdown"
              placeholder="{{ 'AT_A_GLANCE.PAY_GROUP_PLACEHOLDER' | translate}}" [disabled]="!allPayGroups.length"
              [multiple]="true" searchPlaceholder="{{'STALE_DATED_CHECKS.SEARCH' | translate}}"
              [(ngModel)]="editFilters.dashboardFilters.payGroups" bindLabel="code">
              <ukg-select-option *ngFor="let item of allPayGroups" [value]="item" [label]="item.code"></ukg-select-option>
            </ukg-select>
          </ukg-input-container>
        </div>
        <div class="wrap-container vertical-spacing fontstyling flex-row flex-gap-5pct">
          <div class="flex-100">
            <div class="text-muted" data-automation="firstname_edit_label" translate>STALE_DATED_CHECKS.FIRSTNAME_LABEL
            </div>
            <div>
              <ssg-multi-text data-automation="first_name_multiselect" [(ngModel)]="editFilters.firstNames"
                class="filters-input" placeholder="{{ 'STALE_DATED_CHECKS.FIRST_NAME_PLACEHOLDER' | translate }}">
              </ssg-multi-text>
            </div>
          </div>
        </div>
        <div class="wrap-container vertical-spacing fontstyling flex-row flex-gap-5pct">
          <div class="flex-100">
            <div class="text-muted" data-automation="lastname_edit_label" translate>STALE_DATED_CHECKS.LASTNAME_LABEL
            </div>
            <div>
              <ssg-multi-text data-automation="last_name_multiselect" [(ngModel)]="editFilters.lastNames"
                class="filters-input" placeholder="{{ 'STALE_DATED_CHECKS.LAST_NAME_PLACEHOLDER' | translate }}">
              </ssg-multi-text>
            </div>
          </div>
        </div>
        <div class="wrap-container vertical-spacing fontstyling flex-row flex-gap-5pct">
          <div class="flex-100">
            <div class="text-muted" data-automation="employee_number_edit_label" translate>
              STALE_DATED_CHECKS.EMPLOYEE_NUMBER_LABEL</div>
            <div>
              <ssg-multi-text data-automation="employee_id_multiselect" [(ngModel)]="editFilters.employeeNumbers"
                class="filters-input" placeholder="{{ 'STALE_DATED_CHECKS.EMPLOYEE_ID_PLACEHOLDER' | translate }}">
              </ssg-multi-text>
            </div>
          </div>
        </div>
  
        <div class="wrap-container vertical-spacing fontstyling flex-row flex-gap-5pct">
          <div class="flex-100">
            <div>
              <ukg-input-container data-automation="amount_input">
                <ukg-label class="text-muted" data-automation="amount_edit_label"
                  translate>STALE_DATED_CHECKS.CHECK_AMOUNT_LABEL
                </ukg-label>
  
                <ukg-input class="filters-input" type="text" [ngModel]="formattedAmount"
                  [ngModelOptions]="{updateOn:'blur'}" (ngModelChange)="amountChanged($event)"
                  [ngClass]="{'has-danger': editFilters.isAmountTooBig() || editFilters.isAmountTooLow()}"></ukg-input>
              </ukg-input-container>
            </div>
  
            <ukg-label data-automation="amount_too_big_error" *ngIf="editFilters.isAmountTooBig()" class="text-danger"
              translate [translateParams]="{checkAmount: 10000000000000.00 | ulticurrency:'1.02':undefined:true}">
              STALE_DATED_CHECKS.FILTER_AMOUNT_MAX
            </ukg-label>
            <ukg-label data-automation="amount_too_low_error" *ngIf="editFilters.isAmountTooLow()" class="text-danger"
              translate [translateParams]="{checkAmount: -10000000000000.00 | ulticurrency:'1.02':undefined:true}">
              STALE_DATED_CHECKS.FILTER_AMOUNT_MIN
            </ukg-label>
          </div>
        </div>
        
        <div class="wrap-container vertical-spacing fontstyling flex-row flex-gap-5pct">
          <div class="flex-100">
            <div>
              <ukg-input-container data-automation="item_number_input">
                <ukg-label class="text-muted" data-automation="item_number_edit_label" translate>
                  STALE_DATED_CHECKS.CHECK_NUMBER_LABEL</ukg-label>
                <ukg-input class="filters-input" type="text" [(ngModel)]="editFilters.checkNo"></ukg-input>
              </ukg-input-container>
            </div>
          </div>
        </div>
      </div>
    </ssg-side-filter>
  </div>